module.exports = __webpack_public_path__ + "static/media/DA Widget.33bd4717.svg";